module.exports = __webpack_public_path__ + "img/full_red_critical.5da960b0.svg";